import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import OrderSummarySegment from '../components/OrderSummarySegment';
import PageRoot from '../components/PageRoot';
import PageSegment from '../components/PageSegment';
import ResetReservation from '../components/ResetReservation';
import { CONTACT_URL } from '../config';
import withReservation from '../utils/Reservation';

import styles from '../styles/responsive.module.scss';

const Subtitle = styled('div', null, "Subtitle", require("./_confirmation-Subtitle.module.scss"), "subtitle", "subtitle");

const propTypes = {};

function OrderConfirmation({ cart }) {
  return (
    <PageRoot>
      <ResetReservation />
      <PageSegment theme="white" align="center" className={styles.noPrint}>
        <PageSegment.Content>
          <PageSegment.Heading level="1">
            {cart.remote.payment.quoteRequested ? (
              <FormattedMessage
                defaultMessage="Your Electronic Quote is Being Processed"
                id="confirmation.quoteRequested.title"
              />
            ) : (
              <FormattedMessage
                defaultMessage="Order Confirmed"
                id="confirmation.payment.title"
              />
            )}
          </PageSegment.Heading>

          <Subtitle>
            {cart.remote.payment.quoteRequested ? (
              <FormattedMessage
                defaultMessage="You’ll receive an email at {email} with an electronic quote attached and payment instructions. {br}Have questions? Feel free to {contactUs}."
                id="confirmation.subtitle.quote"
                values={{
                  email: cart.email,
                  br: <br />,
                  contactUs: <a href={CONTACT_URL}>Contact Us</a>,
                }}
              />
            ) : (
              <FormattedMessage
                id="confirmation.subtitle.payment"
                defaultMessage={`You’ll receive an email at {email} {shippingMethod, select,
                  STANDARD_SHIPPING {with shipping details}
                  EVENT_PICKUP {with details of how to pick up your order at the event}
                }. {br}Have questions? Feel free to {contactUs}.`}
                values={{
                  email: cart.email,
                  br: <br />,
                  contactUs: <a href={CONTACT_URL}>Contact Us</a>,
                  shippingMethod: cart.remote.cart.shippingMethod,
                }}
              />
            )}
          </Subtitle>
        </PageSegment.Content>
      </PageSegment>

      <OrderSummarySegment />
    </PageRoot>
  );
}

OrderConfirmation.propTypes = propTypes;

export default withReservation(OrderConfirmation);
